var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttachmentNotFound = function SvgAttachmentNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.353 1.977a1 1 0 1 0-1.705 1.045l9.5 15.5a1 1 0 1 0 1.705-1.045l-9.5-15.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 3H8.325l4.463 7.281a1 1 0 0 1 1.576.2l1.759 3.015c.321.549.05 1.215-.487 1.432L16.906 17H17a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-3 3.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 14 6.5Z",
    style: {
      fillRule: "evenodd"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2 4.162 3.7 6.037-1.862 3.31a1 1 0 0 0 .872 1.49h3.933l1.226 2H3a1 1 0 0 1-1-1V4.162Z"
  })));
};
export default SvgAttachmentNotFound;